"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BlockStyle = /** @class */ (function () {
    function BlockStyle() {
    }
    return BlockStyle;
}());
exports.BlockStyle = BlockStyle;
